import {Routes} from '@angular/router';
import {HomeComponent} from './home/home.component';

export const routes: Routes = [
  {
    path: 'qr/:eventId/:guestId/:salt',
    loadChildren: () => import('./qr/qr.routes').then(m => m.QR_ROUTES)
  },
  {path: 'checkin/:eventId', loadChildren: () => import('./checkin/checkin.routes').then(m => m.CHECKIN_ROUTES)},
  {
    path: 'rsvp/:action/:eventId/:guestId/:salt',
    loadChildren: () => import('./rsvp-reply/rsvp-reply.routes').then(m => m.RSVP_REPLY_ROUTES)
  },
  {
    path: 'form/:eventId',
    loadChildren: () => import('./new-guest-form/new-guest-form.routes').then(m => m.NEW_GUEST_FORM_ROUTES)
  },
  {
    path: 'scan-event',
    loadComponent: () => import('./scan-event/scan-event.component').then(m => m.ScanEventComponent)
  },
  {
    path: 'enter-code',
    loadComponent: () => import('./enter-code/enter-code.component').then(m => m.EnterCodeComponent)
  },
  {path: '**', redirectTo: ''},
  {path: '', component: HomeComponent}
];
